"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTransitionGroup = require("react-transition-group");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var InputErrorMessage = function InputErrorMessage(_ref) {
  var error = _ref.error;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-item-error"
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: !!error,
    timeout: 300,
    classNames: "error",
    appear: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "error-message"
  }, error === null || error === void 0 ? void 0 : error.message)));
};
var _default = InputErrorMessage;
exports.default = _default;